module.exports = __webpack_public_path__ + "static/media/full.11e69abc.jpg";